<div class="reports-settings">
  <ng-container [formGroup]="reportForm">
    <div class="reports-settings-container">
      <div class="settings-container-contents">
        <div class="reports-section-header">Report information</div>
        <p>Report Type *</p>
        <mat-radio-group
          [(ngModel)]="currentReportType"
          formControlName="reportType"
          (change)="reportTypeSelect()"
          required
        >
          <mat-radio-button
            [style.border-color]="'rgba(255, 255, 255, 0.3)'"
            value="entity"
            >Entity</mat-radio-button
          >
          <mat-radio-button
            [style.border-color]="'rgba(255, 255, 255, 0.3)'"
            value="portfolio"
            >Portfolio</mat-radio-button
          >
        </mat-radio-group>

        <p>Choose the object to set-up a report for</p>
        <mat-form-field
          appearance="outline"
          class="field-search"
          *ngIf="currentReportType === 'portfolio'"
        >
          <mat-select formControlName="reportObject" required>
            <mat-option
              *ngFor="let option of folio$ | async | orderBy: 'name'"
              [value]="option.uid"
              [disabled]="option.content.length === 0"
              >{{ option.name
              }}{{
                option.content.length === 0 ? ' (Portfolio is empty)' : ''
              }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="field-search"
          *ngIf="currentReportType === 'entity'"
        >
          <mat-label>Search</mat-label>
          <input
            matInput
            type="text"
            [matAutocomplete]="menuSearch"
            [formControl]="searchFormControl"
            required
          />

          <mat-autocomplete
            #menuSearch="matAutocomplete"
            (optionSelected)="onOptionSelected($event.option.value)"
            [autoActiveFirstOption]="true"
            class="searchLetter search-panel"
            panelWidth="auto"
          >
            <div *ngIf="searchItems$ | async as search">
              <div
                *ngFor="
                  let items of search.hits
                    | groupBy: 'entity.type'
                    | orderByType
                    | pairs
                "
              >
                <mat-optgroup>
                  <div class="optgroup-search">
                    <div class="indexo-left">{{ items[0] | nicetxt }}</div>
                    <div class="indexo-right">
                      <div class="optgroup-column column-1">Country</div>
                      <div class="optgroup-column"># Articles</div>
                    </div>
                  </div>
                  <ng-container *ngFor="let option of items[1]">
                    <mat-option
                      *ngIf="!option.entity.hasParent"
                      [value]="option"
                    >
                      <div class="search-indexo">
                        <div class="indexo-left">
                          <span>{{ option.entity.name }}</span>
                          <span class="match">{{
                            option.entity.matched_form
                              ? option.entity.matched_form
                              : ''
                          }}</span>
                        </div>
                        <div class="indexo-right">
                          <div class="optgroup-column column-1">
                            {{
                              option.entity &&
                              option.entity.country &&
                              option.entity.country.alpha_id
                                ? option.entity.country.alpha_id.toUpperCase()
                                : '\u2014'
                            }}
                          </div>
                          <div class="optgroup-column">
                            {{ numberFormat(option.count) }}
                          </div>
                        </div>
                      </div>
                    </mat-option>
                    <mat-option
                      *ngFor="let optionChild of option.entity.children"
                      [value]="optionChild"
                    >
                      <div class="search-indexo">
                        <div class="indexo-left">
                          <span class="subsidiary">{{
                            optionChild.entity.name
                          }}</span>
                          <span
                            class="match"
                            *ngIf="iMatch(optionChild.entity)"
                            >{{
                              optionChild.entity.matched_form
                                ? optionChild.entity.matched_form
                                : ''
                            }}</span
                          >
                        </div>
                        <div class="indexo-right">
                          <div class="optgroup-column column-1">
                            {{
                              optionChild.entity &&
                              optionChild.entity.country &&
                              optionChild.entity.country.alpha_id
                                ? optionChild.entity.country.alpha_id.toUpperCase()
                                : '\u2014'
                            }}
                          </div>
                          <div class="optgroup-column">
                            {{ numberFormat(optionChild.count) }}
                          </div>
                        </div>
                      </div>
                    </mat-option>
                  </ng-container>
                </mat-optgroup>
              </div>
            </div>
          </mat-autocomplete>
          <mat-spinner [diameter]="15" *ngIf="loadingSearch"></mat-spinner>
        </mat-form-field>
        <p>Choose the score</p>
        <mat-form-field class="field-subalert type" appearance="outline">
          <mat-select formControlName="score" required>
            <mat-option
              *ngFor="let score of scoreTypes"
              [value]="score.value"
              >{{ score.label }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <p>Schedule</p>
        <mat-form-field class="field-subalert type" appearance="outline">
          <mat-select formControlName="schedule" required>
            <mat-option
              *ngFor="let schedule of schedules"
              [value]="schedule.value"
              >{{ schedule.label }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="field-type">
          <mat-label>Additional Recipients from {{ domain }}</mat-label>
          <mat-chip-list #chipListAlertRecipients aria-label="Email selection">
            <mat-chip
              *ngFor="let item of emailList"
              [selectable]="true"
              [removable]="true"
              (removed)="removeEmail(item)"
            >
              {{ item }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input
              matInput
              [matChipInputFor]="chipListAlertRecipients"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addEmail($event)"
            />
          </mat-chip-list>
        </mat-form-field>
      </div>
    </div>
    <div class="reports-settings-footer">
      <button
        class="delete"
        mat-button
        (click)="deleteReport()"
        *ngIf="!isNewReport"
      >
        <mat-icon>delete</mat-icon>
        <span>DELETE</span>
      </button>

      <button
        class="save"
        mat-button
        (click)="saveReport()"
        [class.valid-report]="reportForm.valid"
      >
        <mat-icon>save</mat-icon>
        <span>SAVE</span>
      </button>
    </div>
  </ng-container>
</div>
